export default class Message {
  public static of(value: string): Message {
    return new Message(value);
  }

  public static empty(): Message {
    return Message.of("");
  }

  private readonly _value: string = "";

  constructor(value: string) {
    this._value = value;
  }

  public isEmpty(): boolean {
    return !this._value;
  }

  get value() {
    return this.isEmpty() ? "" : this._value;
  }
}